import { WORKSHOPS } from 'composer-blocks/lib/constants/BlockTypes';
import * as contentTypes from 'composer-blocks/lib/constants/ContentTypes';

export default {
  id: 'workshops_3',
  type: WORKSHOPS,
  name: 'Activity rectangles',
  thumbnail: 'https://eventtia-composer.s3.amazonaws.com/assets/images/thumbnails/workshops/workshops_3.png',
  rootContent: {
    type: contentTypes.WORKSHOP_RECTANGLES,
    properties: {
      backgroundColor: {type: 'css', value: '#FFFFFF', editable: true},
      workshopTextColor: {type: 'custom', value: '#FFFFFF', editable: true},
      workshopColor: {type: 'custom', value: '#2A315A', editable: true},
      workshopAccentColor: {type: 'custom', value: '#F5A623', editable: true},
    }
  }
}
